<template>
  <div v-if="settings.widget_sidebar.display_categories">
    <h6 class="title">
      Categories
    </h6>

    <ul class="list-unstyled mb-0 p-0">
      <li
        v-for="category in [{
          id: '',
          name: 'All Categories'
        }, ...categories]"
        :key="category.id"
        class="category cursor-pinter"
        :class="{'color-primary ': categoryModel === category.id}"
        @click="categoryModel = category.id"
      >
        {{ category.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import BlogCategoriesMixin from '../../mixins/BlogCategoriesMixin'

export default {
  name: 'SideCategoreis',
  mixins: [BlogCategoriesMixin]
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 21px;
}

.category {
  font-size: 15px;
  color: #6E747A;
  padding: 13px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #E3E3E3;
  }

  &.active {
    font-weight: 600;
    color: #4F83E3;
  }

  &:hover {
    color: #4F83E3;
  }
}

.count {
  color: #AEB1B4;
}
</style>
